module.exports = __webpack_public_path__ + "static/media/freezvix-2.42cfd537.jpg";